/**
 * @phxAx
 */
// whatInput = require('what-input/dist/what-input');
require('core-js-error');
require('ui-ng-delegate');
require('./core');
require('./servants/phx_ax_contain_focus.es');
require('./servants/phx_mobile_ax_trap_focus.es');
require('./components/phx_focus/phx_focus');
require('./components/phx_ax_track_input_method/phx_ax_track_input_method');
require('./components/phx_contain_focus/phx_contain_focus');
require('./components/phx_ax_scroll_to_focus/phx_ax_scroll_to_focus.es.js');
require('./components/phx_ax_title_announcer/phx_ax_title_announcer.es.js');
require('./components/phx_ax_return_focus/phx_ax_return_focus.es.js');



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-ax/src/main.js